import React from "react";

const UserDeleteMessage = () => {
  return (
    <div className="container">
      <div className="row mt-5 d-flex justify-content-center">
        <div className="col-lg-6 mt-5 col-md-8 col-12">
          <div className="content-card text-center">
            <h3 className="mb-3">Account deleted</h3>
            <p className="body-lg mb-0">
              Your account and all its data have been deleted successfully.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDeleteMessage;
